import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useTogglePublishedKimThread = (matterId?: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (threadId: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/toggle-published`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Toggling thread publish status failed');
      }
      return response.json();
    },
    {
      onSuccess: (_data, threadId) => {
        queryClient.invalidateQueries([QueryEntity.KimThread, { threadId }]);
        queryClient.invalidateQueries([QueryEntity.KimThreads, { subsetId }]);
      },
      onError: () => {
        toast.error('Failed to update thread. Please try again.');
      },
    },
  );
};
